const mock = {
    "results": {
      "score": 9,
      "maxScore": 10
    },
    "submissionDate": null,
    "passed": true,
    "sealed": false,
    "questions": [
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "a7ef20d6-23df-40df-b0d7-a0fcd6f01ccb",
        "type": "MultiChoice",
        "content": "Which one is the wrong answer for the check-in procedure?",
        "options": [
          {
            "id": 0,
            "value": "Provide room number either verbally or non-verbally"
          },
          {
            "id": 1,
            "value": "To offer assistance for the internet during check in"
          },
          {
            "id": 2,
            "value": "Ask the number of room keys required"
          },
          {
            "id": 3,
            "value": "Use appropriate verbiage with genuine delivery"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "814def0e-01da-4e8c-a1b9-db530ee3e6a8",
        "type": "SingleChoice",
        "content": "Maintaining poor posture, a smile, eye contact, and attentive listening is the responsibility of every front desk agent throughout guest interactions.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "97ac92dc-d686-44d4-9733-fc772ea989ba",
        "type": "MultiChoice",
        "content": "What should a front desk team member do when the guest's name is known?",
        "options": [
          {
            "id": 0,
            "value": "Avoid using the guest's name to maintain formality"
          },
          {
            "id": 1,
            "value": "Use the guest's name during the experience"
          },
          {
            "id": 2,
            "value": "Use a nickname instead of the guest's name if he used it when booking"
          },
          {
            "id": 3,
            "value": "Ask the guest if it's okay to use their name"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "4c696e0f-276f-4536-86c0-82a606680cb7",
        "type": "SingleChoice",
        "content": "What should an attendant do if a guest's problem cannot be resolved within 10 minutes?",
        "options": [
          {
            "id": 0,
            "value": "Apologize and offer a discount"
          },
          {
            "id": 1,
            "value": "Seek a manager's assistance promptly"
          },
          {
            "id": 2,
            "value": "Ignore the issue and move on"
          },
          {
            "id": 3,
            "value": "Extend the resolution time with guest consent"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "9dffdb81-0bc3-48da-adef-a721c129e669",
        "type": "MultiChoice",
        "content": "What is the length of check in process according to the standards?",
        "options": [
          {
            "id": 0,
            "value": "4 minutes"
          },
          {
            "id": 1,
            "value": "5 minutes"
          },
          {
            "id": 2,
            "value": "7 minutes"
          },
          {
            "id": 3,
            "value": "10 minutes"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "4039c6da-2c29-4675-b687-07acf607b1c7",
        "type": "SingleChoice",
        "content": "It is not obligatory to recognize all Marriott Bonvoy members during their check in.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "290858f3-e5d0-479f-9bfd-25ecc8d359b7",
        "type": "SingleChoice",
        "content": "Why is allowing the guest to enter/exit the elevator first considered a luxury service?",
        "options": [
          {
            "id": 0,
            "value": "It saves time"
          },
          {
            "id": 1,
            "value": "It's a safety requirement"
          },
          {
            "id": 2,
            "value": "It emphasizes guest priority"
          },
          {
            "id": 3,
            "value": "It prevents overcrowding"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "37f36c0c-0f46-472f-8b99-c066700cead8",
        "type": "MultiChoice",
        "content": "What should frond desk agent do when need to decline the guest’s request?",
        "options": [
          {
            "id": 0,
            "value": "Offer alternative option"
          },
          {
            "id": 1,
            "value": "Tell him/her to ask anyone else"
          },
          {
            "id": 2,
            "value": "Say ‘’No’’ when the request cannot be completed"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "7112ea86-82e6-4059-b998-a362b6325fd8",
        "type": "MultiChoice",
        "content": "How many times an associate needs to repeat the guest’s name during conversation?",
        "options": [
          {
            "id": 0,
            "value": "As many as possible"
          },
          {
            "id": 1,
            "value": "Not more than one"
          },
          {
            "id": 2,
            "value": "Not more than three"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "f6d5227d-0233-4a54-8b13-66c7b16d9670",
        "type": "SingleChoice",
        "content": "Check out service is being provided within 6 minutes.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      }
    ],
    "answers": null,
    "startsAt": "2024-09-28T21:07:55.6702916+00:00",
    "endsAt": "2024-09-30T21:07:55.6702923+00:00"
  };
export default mock;